import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';
import familyConfig from '../../familyConfig';
import store from '../../store';
import {selectFamilyConfig} from '../../selectors';

@customElement('family-tiles')
export class FamilyTiles extends connect(store)(LitElement) {

	static styles = css`
		:host {}

		.familyOverview {
			display: flex;
			flex-wrap: wrap;
		}
		.familyTile {
			min-width: 240px;
			max-width: 320px;
			aspect-ratio: 1;
			flex-grow: 1;
			background-color: #000;
			margin: 1px 1px 0 0;
			display: flex;
			justify-content: center;
			text-decoration: none;
			background-size: 75%;
			background-position: 50% 10%;
		}
		.empty {
			background-color: transparent;
			aspect-ratio: 100/1;
		}
		.label {
			font: var(--font-light);
			font-size: 2.2rem;
			font-weight: 400;
			letter-spacing: .5rem;
			pointer-events: none;
			text-transform: uppercase;
			color: #fff;
			opacity: 1;
			align-self: start;
			margin-top: 2rem;
			width: 240px;
			text-align: center;
			transition: font-size 0.25s ease-out;
		}
		.familyTile:hover .label {
		}


	`;

	@property()
	active = false;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.host = state.status.host;
		this.base = state.status.baseUrl;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.families = familyConfig;
		if (this.lang && this.lang !== '') {
			// wait for language to be available
			// convert this.families object to array and put the objects ids into each item
			this.familiesArray = Object.entries(this.families)
				.map(([name, config]) => ({id: name, ...config}))
				.filter(family => family.hasWizard)
				.sort((a, b) => a.label[this.lang].localeCompare(b.label[this.lang]));
		} else {
			this.familiesArray = null;
		}
	}

	connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	familyUrl(familId) {
		const region = this.region;
		const lang = this.lang;

		let route = '';
		if (this.host === 'https://selux.com' || this.host === 'https://www.selux.cdlx.dev') {
			route = `/${region}/${lang}/datahub?family=${familId}`;
		} else {
			route = `/demo.php?region=${region}&lang=${lang}&family=${familId}`;
		}
		return route;
	}
	render() {
		if (!this.familiesArray) return null;

		const currentConfig = selectFamilyConfig(this.state);
		let familyLabel = msg('Choose a Product Family');
		if (currentConfig && currentConfig?.label) {
			familyLabel = currentConfig?.label[this.lang];
		}
		return html`
			<div class="familyOverview">
					${repeat(
						this.familiesArray,
						(family) => family.id,
						(family) => html`
							<a class="familyTile" href="${this.familyUrl(family.id)}" style="background-image: url('${this.host}${this.base}/line-assets/img/families/${family.image}')">
								<div class="label">${family.label[this.lang]}</div>
							</a>
						`)

					}
				<!-- keep grid aligned -->
				<div class="familyTile empty"><div class="label"></div></div>
				<div class="familyTile empty"><div class="label"></div></div>
				<div class="familyTile empty"><div class="label"></div></div>
				<div class="familyTile empty"><div class="label"></div></div>
				<div class="familyTile empty"><div class="label"></div></div>
				<div class="familyTile empty"><div class="label"></div></div>
				<div class="familyTile empty"><div class="label"></div></div>
				<div class="familyTile empty"><div class="label"></div></div>
			</div>
		`;
	}
}
